import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class CiqHttpInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
    const { url } = request;
    const headers = new HttpHeaders().set('Access-Control-Allow-Origin', '*');
    if (url.includes('ciq/services')) {
      const nextRequest = request.clone({
        headers: headers.set('Authorization', `Bearer ${localStorage.getItem('ciq_token')}`),
      });
      return next.handle(nextRequest);
    }
    if (url.includes('ciq/token')) {
      const nextRequest = request.clone({
        headers,
      });
      return next.handle(nextRequest);
    }
    return next.handle(request);
  }
}
